import React from 'react';
import styles from './styles.module.scss';
import { ClockIcon } from 'v2/icons';
import { ArtificialProposalResponse } from 'v2/models';

interface SearchArtificialProposalResponseItemProps {
  artificialProposalResponse: ArtificialProposalResponse;
}

export function SearchArtificialProposalResponseItem({
  artificialProposalResponse,
}: SearchArtificialProposalResponseItemProps) {
  return (
    <div className={styles.responseContainer}>
      <div className={styles.leftPane}>
        <div className={styles.responseDetails}>
          <h5 className={styles.title}>Generated Response:</h5>

          <p className={styles.hint}>
            This is an automatically generated response based on real responses
            from this provider.
          </p>

          <p className={styles.response}>
            {artificialProposalResponse.response}
          </p>
        </div>

        <div className={styles.informationNoteContainer}>
          <ClockIcon />

          <p>
            <b>The provider is generating an actual response.</b> We will email
            you when it has been delivered.
          </p>
        </div>
      </div>

      <div className={styles.rightPane}>
        <h5 className={styles.title}>
          {artificialProposalResponse.data_provider.classification}
        </h5>

        <p className={styles.hint}>
          {artificialProposalResponse.data_provider.anonymous_description}
        </p>
      </div>
    </div>
  );
}
